import { useEffect } from 'react'
import i18n from 'i18next'
import { AppRouter } from './AppRouter'
import 'swiper/css'
import 'swiper/css/free-mode'
import 'swiper/css/thumbs'
import '../i18n/i18n'

const App = () => {

  useEffect(() => {
    const handleLanguageChange = (lng: any) => {
      const dir = lng === 'ar' ? 'rtl' : 'ltr'

      document.documentElement.dir = dir
      document.documentElement.lang = lng

      document.body.classList.remove('rtl', 'ltr')
      document.body.classList.add(dir)
    }

    handleLanguageChange(i18n.language)

    i18n.on('languageChanged', handleLanguageChange)

    return () => {
      i18n.off('languageChanged', handleLanguageChange)
    }
  }, [])

  return <AppRouter />
}

export default App
